import { Swiper, Navigation, Pagination, Thumbs, Controller } from 'swiper';
import elementExists from "../../core/utils/element-exists"

const TwoColumnSwiper = function () {
        const sections = document.querySelectorAll( '.two-column-swiper.has-swiper' );
        if ( Object.keys(sections).length ) {
            // Related Recipes Section
            sections.forEach( function( el ){
                const container = el;
                const swiperContainer = container.querySelector( '.swiper');
                let btnNexts = container.querySelectorAll('.swiper-button-next');
                let btnPrevs = container.querySelectorAll('.swiper-button-prev');
                let pagination = container.querySelector('.swiper-pagination');

                if( elementExists( swiperContainer)){
                    const swiper = new Swiper( swiperContainer , {
                        direction: 'horizontal',
                        slidesPerView: 1,
                        spaceBetween: 0,
                        autoHeight: true,
                        pagination: {
                            el: pagination
                        }
                    })
                    if ( elementExists( btnNexts, true )){
                        btnNexts.forEach( btn => {
                            btn.addEventListener( 'click' , e => {
                                swiper.slideNext();
                            })
                        })                    
                    }
                    if ( elementExists( btnPrevs, true )){
                        btnPrevs.forEach( btn => {
                            btn.addEventListener( 'click' , e => {
                                swiper.slidePrev();
                            })
                        })                    
                    }        
                    /** 
                     * Theme Editor Functions
                    document.addEventListener( 'shopify:block:select' , evt => {
                        
                        const el = document.querySelector( '#shopify-section-' + evt.detail.sectionId );
                        swiper.slideTo( 2 )
                        console.log( evt.detail)
                        console.log( el )
                        console.log( evt.detail.sectionId)
                        console.log( el.classList );
                        if( el.classList.contains( 'two-column-swiper')){
                            alert( 'is this swiper ')
                        }
                    })
                     */

                }
            });
        }



}
  

export default TwoColumnSwiper;